import useGame from "./stores/useGame"

import './style.css'

export default function UI()
{
    
    const phase = useGame((state) => state.phase)
    const play =  useGame((state) => state.play)
    const toggleTouch = useGame((state) => state.toggleTouch)
    const togglePlay = useGame((state) => state.togglePlay)
    const reset = useGame((state) => state.reset)
    
    const titleClick = () => {
        toggleTouch();
        togglePlay();
      }

        return <>

        <div className='banner-top'>
            <img src="./DSL_Logo_stackedonWHT_Transp_Web_120.png" className="image-wrap" onClick={()=>{window.open('https://www.darkstarlabs.io/')}}></img>
            <div className="action-card-row" onClick={()=>{window.open('https://www.darkstarlabs.io/contact')}}>
                <div className='text-button-row'>Talk to the team</div>
                <div className='dot'>?</div>    
                
            </div> 
        </div> 
            
        
        { play === true &&  <div className='interface'>

        <div className="action-card" onClick={titleClick} >
            <div className='title-lower-banner'>MAY THE 4TH BE WITH YOU!</div>
            <div className='text-button-row'>Click to explore the CR90 Corellian Corvette</div>
        </div> 

        </div> }

        <div id="p1" className='p'>
            <div className='heading'>Bridge</div>
            <div className='body'>All operations were ran in the Bridge, weapons, navigation and stealing secret plans. </div>
            <div className='body'>On the infamous Tantive IV, Captain Antilles was dragged kicking and screaming from here.</div>
            <div className='reset' onClick={() => {reset()}}>BACK</div>
        </div> 

        <div id="p2" className='p'>
            <div className='heading'>Turbo Laser</div>
            <div className='body'>The main weapon system of this Corellian Corvette, though slow to target, the dorsal and ventral batteries pack a punch, making most pursuers think twice before attacking.</div>
            <div className='reset' onClick={() => {reset()}}>BACK</div>
        </div> 

        <div id="p3" className='p'>
            <div className='heading'>Escape Pods </div>
            <div className='body'>Numerous escape pods provided a means for personnel to evacuate the vessel in dire situations, as seen when Princess Leia dispatched R2-D2 and C-3PO with the Death Star plans.</div>
            <div className='reset' onClick={() => {reset()}}>BACK</div>
        </div> 

        <div id="p4" className='p'>
            <div className='heading'>Main Deflector Array</div>
            <div className='body'>A vital system for protection, the deflector array generated energy shields that could absorb or deflect incoming enemy fire and debris.</div>
            <div className='reset' onClick={() => {reset()}}>BACK</div>
        </div> 

        <div id="p5" className='p'>
            <div className='heading'>Docking Hatch</div>
            <div className='body'>Enabling the transfer of personnel and cargo, the docking hatch facilitated connections with other vessels and space stations.</div>    
            <div className='reset' onClick={() => {reset()}}>BACK</div>
        </div> 

        <div id="p6" className='p'>
            <div className='heading'>Sublight Engines</div>
            <div className='body'>Powerful sublight engines allowed the CR90 to maneuver and travel within star systems at significant speeds, crucial for evading threats or reaching destinations quickly.</div>
            <div className='reset' onClick={() => {reset()}}>BACK</div>
        </div> 

    </>
}





